import React from 'react';

import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { layout, spacing } from 'styles/constants';

const FORM_SPACING = spacing.$1;

const styles = StyleSheet.create({
  cardNumberWrapper: {
    marginBottom: FORM_SPACING,
    position: 'relative',
  },
  expiryCVVWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: layout.full,
  },
  expiryWrapper: {
    marginBottom: FORM_SPACING,
    marginRight: spacing.$4,
    width: '50%',
  },
  cvvWrapper: {
    flexGrow: 1,
    flexShrink: 1,
    marginBottom: FORM_SPACING,
    width: '50%',
  },
});

export const StyledExpiryCVVWrapper = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.expiryCVVWrapper, style] });

export const StyledExpiryWrapper = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.expiryWrapper, style] });

export const StyledCvvWrapper = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.cvvWrapper, style] });

export const CardNumberWrapper = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.cardNumberWrapper, style] });
